import { LeadScore } from "../../../types"
import LeadScoreCard from "./lead-score-card"

interface Props {
  scores: LeadScore[]
  selectedIds: Set<string>
  optimisticAckedIds: Set<string>
  onToggleSelect: (id: string) => void
  onSelectAll: () => void
  onClearSelection: () => void
  onAcknowledge: (id: string) => void
  onUndoAcknowledge: (id: string) => void
}

const LeadScoreList = ({
  scores,
  selectedIds,
  optimisticAckedIds,
  onToggleSelect,
  onSelectAll,
  onClearSelection,
  onAcknowledge,
  onUndoAcknowledge
}: Props) => {
  const allSelected =
    scores.length > 0 && scores.every(s => selectedIds.has(s.id))
  const someSelected = scores.some(s => selectedIds.has(s.id))

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 px-2 py-1.5">
        <input
          type="checkbox"
          checked={allSelected}
          ref={el => {
            if (el) el.indeterminate = someSelected && !allSelected
          }}
          onChange={() => (allSelected ? onClearSelection() : onSelectAll())}
          className="h-4 w-4 rounded border-neutral-300 text-primary-400 focus:ring-primary-400 cursor-pointer"
          aria-label="Select all leads"
        />
        <span className="text-xs text-neutral-400">
          {scores.length} lead{scores.length !== 1 ? "s" : ""}
          {someSelected && (
            <span className="text-primary-500 font-medium ml-1">
              ({selectedIds.size} selected)
            </span>
          )}
        </span>
      </div>
      {scores.map((score, index) => (
        <LeadScoreCard
          key={score.id}
          score={score}
          index={index}
          isSelected={selectedIds.has(score.id)}
          isOptimisticallyAcked={optimisticAckedIds.has(score.id)}
          onToggleSelect={onToggleSelect}
          onAcknowledge={onAcknowledge}
          onUndoAcknowledge={onUndoAcknowledge}
        />
      ))}
    </div>
  )
}

export default LeadScoreList
